import { Component, HostListener,OnInit, Inject } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-phoenix',
  templateUrl: './phoenix.component.html',
  styleUrls: ['./phoenix.component.scss']
})
export class PhoenixComponent implements OnInit {
  public ngxScrollToOffset: number;
  constructor(@Inject(DOCUMENT) document) {
    this.ngxScrollToOffset = 40;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {

    if (window.pageYOffset > 30) {
      let element2 = document.getElementById('fixed-right');
      element2.classList.add('top-0');

    } else {
      let element2 = document.getElementById('fixed-right');
      element2.classList.remove('top-0');
    }
  }
}
